import { FC } from "react"
import { t } from "i18next";
import { useWatch } from "react-hook-form";

// Utilities
import { roundNumber } from "@/_helpers/number_functions";

// Components
import { Box, Skeleton } from "@mui/material";
import MacroIndicator from "@/components/nutrition_builder/widgets/macro_indicator";
import MacroProgressWheel from "@/components/nutrition_builder/widgets/macro_wheel";

interface _MacroHeaderProps {
    isLoading?: boolean;
}

const MacroHeader: FC<_MacroHeaderProps> = ({
    isLoading
}) => {

    const calories = useWatch({ name: 'calories' }) ?? 0;
    const protein = useWatch({ name: 'protein' }) ?? 0;
    const carbs = useWatch({ name: 'carbs' }) ?? 0;
    const fat = useWatch({ name: 'fat' }) ?? 0;
    const servings = useWatch({ name: 'servings' }) ?? 1;

    return (
        <Box 
            display="grid" 
            gridTemplateColumns="repeat(4, 1fr)"
            padding="16px 24px"
            gap={3}
            boxSizing="border-box"
            bgcolor="var(--layer-01)"
            border="solid 1px var(--border-subtle-01)" 
            borderRadius="6px"
            >

            <Box display="flex" alignItems='center' columnGap="16px" minWidth="130px">
                
                <MacroProgressWheel
                    calories={calories}
                    protein={protein}
                    carbs={carbs}
                    fat={fat}
                    />

                <Box display="flex" flexDirection="column" alignItems="flex-start">
                    {isLoading ? 
                        <Skeleton variant="rectangular" width={110} height={18} /> :
                        <span className="label-text-01">{`${roundNumber(calories/(servings ?? 1), 0)} ${t('metrics.kcal')}`}</span>}
                    {isLoading ? 
                        <Skeleton variant="rectangular" width={110} height={16} /> :
                        <span className="label-text-02" style={{color: 'var(--text-secondary)', whiteSpace: 'nowrap'}}>
                            {t('components.recipeBuilder.perServing')}
                        </span>}
                </Box>
            </Box>

            <MacroIndicator
                macro="protein"
                value={protein}
                calories={calories}
                servings={servings}
                isLoading={isLoading}
                />
            <MacroIndicator
                macro="carbs"
                value={carbs}
                calories={calories}
                servings={servings}
                isLoading={isLoading}
                />
            <MacroIndicator
                macro="fat"
                value={fat}
                calories={calories}
                servings={servings}
                isLoading={isLoading}
                />
        </Box>
    )
}

export default MacroHeader;